<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <form>
          <div v-if="courses.length>0 && activeShifts.length" class="my-5 offset-sm-1"> <h4>Acerca del cursillo de apoyo</h4>
            <div class="my-5 offset-sm-1"></div>
            <input type="checkbox" v-model="item.hasCourseSelected" id="hasSiblings" class="form-check-input" v-on:change="cleanCourses()">
                <label class="form-check-label" style="margin-left: 2.5rem;" for="accept">Deseo que el aspirante realice el cursillo de apoyo</label>
            <div v-if="courses.length>0 && item.hasCourseSelected && activeShifts.length>0" class="row">
              <div class="col-sm-4 ">
                <div class="form-group" :class="{ 'form-group--error': $v.item.minicourseSelected.$error }">
                    <div class="fg-line">
                        <div class="my-5 offset-sm-1" ></div>
                        <label>¿En qué turno preferiría realizar el cursillo?</label>
                        <div v-for="course in courses" :key="course.id">
                          <div class="select">
                              <select v-model="item.minicourseSelected" id="minicourseCode" name="minicourseSelected" class="form-control"> <!-- v-validate="'required'" -->
                                  <option value="">[Seleccione una opción]</option>
                                  <option v-for="minicourse of activeShifts" :key="minicourse" :value="minicourse">{{ minicourse.name }}</option>
                              </select>
                          </div>
                        </div>
                    </div>
                    <div class="error" v-if="!$v.item.minicourseSelected.required">Campo requerido</div>
                </div>
              </div>
            </div>
          </div>
          <div class="my-5 offset-sm-1"><h4>Acerca de la escuela de procedencia</h4></div>
          <div class="row">
            <div class="col-sm-4 offset-sm-1">
              <div class="form-group" :class="{ 'form-group--error': $v.item.previousSchool.$error }">
                <label for="previousSchool">Nombre de la escuela primaria de procedencia</label>
                <input
                  type="text"
                  class="form-control"
                  id="previousSchool"
                  aria-describedby="emailHelp"
                  v-model="item.previousSchool"
                />
                <div class="error" v-if="!$v.item.previousSchool.required">Campo requerido</div>
              </div>
            </div>
            <div class="col-sm-3 offset-sm-1">
              <div class="form-group" :class="{ 'form-group--error': $v.item.latestGradeSelected.$error }">
                  <div class="fg-line">
                      <label>¿Qué grado cursa el aspirante?</label>
                      <div class="select">
                          <select v-model="item.latestGradeSelected" id="gradeCode" name="latestGradeSelected" class="form-control"> <!-- v-validate="'required'" -->
                              <option value="">[Seleccione una opción]</option>
                              <option v-for="grade of latestGrades" :key="grade.id" :value="grade">{{ grade.name }}</option>
                          </select>
                      </div>
                  </div>
                  <div class="error" v-if="!$v.item.latestGradeSelected.required">Campo requerido</div>
              </div>
            </div>
            <div class="col-sm-2 ">
              <div class="form-group" :class="{ 'form-group--error': $v.item.schoolTypeSelected.$error }">
                  <div class="fg-line">
                      <label>¿Qué tipo de colegio es?</label>
                      <div class="select">
                          <select v-model="item.schoolTypeSelected" id="schoolTypeCode" name="schoolTypeSelected" class="form-control"> <!-- v-validate="'required'" -->
                              <option value="">[Seleccione una opción]</option>
                              <option v-for="schoolType of schoolTypes" :key="schoolType.id" :value="schoolType">{{ schoolType.name }}</option>
                          </select>
                      </div>
                  </div>
                  <div class="error" v-if="!$v.item.schoolTypeSelected.required">Campo requerido</div>
              </div>
            </div>
          </div>
          <div class="my-5 offset-sm-1"> <h4>En caso de ingresar al Colegio Nacional de Monserrat</h4></div>
          <div class="row">
            <div class="col-sm-4 offset-sm-1">
              <div class="form-group" :class="{ 'form-group--error': $v.item.preferredShiftSelected.$error }">
                  <div class="fg-line">
                      <label>¿En qué turno preferiría cursar el aspirante? </label>
                      <div class="select" >
                          <select v-model="item.preferredShiftSelected" id="minicourseCode" name="preferredShiftSelected" class="form-control"> <!-- v-validate="'required'" -->
                              <option value="">[Seleccione una opción]</option>
                              <option v-for="preferred of preferredShifts" :key="preferred.id" :value="preferred">{{preferred.name}}</option>
                          </select>
                      </div>
                  </div>
                  <div class="error" v-if="!$v.item.preferredShiftSelected.required">Campo requerido</div>
              </div>
            </div>
            <div class="col-sm-4 offset-sm-1">
              <div class="form-group">
                <label for="comment">Comentario </label>
                <textarea maxlength="150" class="form-control" aria-label="With textarea" v-model="item.comment"></textarea>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6 offset-sm-1">
              <div class="form-group " :class="{ 'form-group--error': $v.item.siblings.$error }">
                <input type="checkbox" v-model="item.hasSiblings" id="hasSiblings" class="form-check-input" v-on:change="cleanSiblings()">
                <label class="form-check-label" style="margin-left: 2.5rem;" for="accept">Tiene hermano/a cursando en el Colegio Nacional de Monserrat</label>
                <br><span v-if="item.hasSiblings">Si tiene hermano/a complete los datos y haga click en el botón "Agregar hermano/a"</span>
              </div>
              <div class="error" v-if="!$v.item.siblings.required">Campo requerido</div>
            </div>
          </div>
          <div v-if="item.hasSiblings">

            <div class="row">
              <div class="col"  v-if="item.siblings.length>0">
                <div class="row" v-for="sib in item.siblings" :key="sib.documentNumber">
<!--                   <div class="col-sm-2 offset-sm-1"	>
                    <div class="form-group" >
                      <label for="siblingName">Nombre</label>
                      <input
                        type="text"
                        class="form-control-plaintext"
                        id="siblingName"
                        aria-describedby="emailHelp"
                        v-model="sib.name"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="form-group">
                      <label for="siblingLastName">Apellido</label>
                      <input
                        type="text"
                        class="form-control-plaintext"
                        id="siblingLastName"
                        aria-describedby="emailHelp"
                        v-model="sib.lastName"
                      />
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="form-group">
                      <label for="asiblingDni">DNI</label>
                      <input
                        type="text"
                        class="form-control-plaintext"
                        id="siblingDni"
                        aria-describedby="emailHelp"
                        v-model="sib.documentNumber"
                      />
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="form-group">
                      <label for="siblingDivision">División</label>
                      <input
                        type="text"
                        class="form-control-plaintext"
                        id="siblingDivision"
                        aria-describedby="emailHelp"
                        v-model="sib.division"
                      />
                    </div>
                  </div>
                  <div class="col-sm-1">
                    <div class="form-group">
                      <div><a style="color:red;" href="" @click.prevent="deleteSibling(index)" title="Borrar hermano"><i style="font-size:25px" class="zmdi zmdi-delete"></i></a></div>
                    </div>
                  </div> -->

                  <div class="col">
                    <div class="row row-cols-1 row-cols-sm-2" id="rowppal" >
                      <div class="col-11 col-sm-7 offset-sm-1" >
                        <div class="row row-cols-2 justify-content-end " >
                          <div class="col-1 col-sm-1" style="padding: 0px;text-align: end;">
                                <a style="color:gray;" href="" @click.prevent="deleteSibling(index)" title="Borrar hermano"><i style="font-size:21px" class="zmdi zmdi-close-circle"></i></a>
                          </div>
                          <div class="col-10 col-sm-10 "  >
                            <div >
                              <div class=""><h5 style="margin-top:3px!important">{{sib.lastName +', '+ sib.name+' '}}</h5></div>
                            </div>
                            <div class="">
                              DNI: {{sib.documentNumber}}
                            </div>
                            <div class="">
                              División: {{sib.division}}
                            </div>
                            <div class="my-5 offset-sm-1"></div>
                          </div>
                        </div>
                      </div>
                      <div class="col-1 col-sm-5">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-for="bro in item.bros" :key="bro.dniNumber">
              <div class="col-sm-2 offset-sm-1"	>
                <div class="form-group" >
                  <label for="siblingName">Nombre</label>
                  <input
                    :required="item.hasSiblings ? true : false"
                    type="text"
                    class="form-control"
                    id="siblingName"
                    aria-describedby="emailHelp"
                    v-model="bro.name"
                  />
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <label for="siblingLastName">Apellido</label>
                  <input
                    type="text"
                    class="form-control"
                    id="siblingLastName"
                    aria-describedby="emailHelp"
                    v-model="bro.lastName"
                  />
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <label for="asiblingDni">DNI</label>
                  <input
                    type="text"
                    class="form-control"
                    id="siblingDni"
                    aria-describedby="emailHelp"
                    v-model="bro.documentNumber"
                  />
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group">
                  <label for="siblingDivision">Curso y división</label>
                  <input
                    type="text"
                    class="form-control"
                    id="siblingDivision"
                    aria-describedby="emailHelp"
                    v-model="bro.division"
                  />
                </div>
              </div>
              <div class="col-sm-1">
                <div class="form-group">
                  <button type="button" class="btn btn-primary"  @click="addSibling(bro)">Agregar hermano/a</button>
                </div>
              </div>
            </div>
          </div>
          <div class="my-5 offset-sm-1"> <h4>Aceptación de Normativa</h4></div>
          <div class="my-5 offset-sm-1">
              <input type="checkbox" v-model="item.hasStatementSelected" id="hasStatementSelected"  class="form-check-input">
                <label class="form-check-label" style="margin-left: 2.5rem;" for="accept"><font size=2>Declaro conocer y acepto la siguiente normativa referida al examen de ingreso:</font></label>
                <br><p style="margin-left: 2.5rem;"><font size=1.5>
                - La capacidad de ingresantes es de 240 lugares, asignada en dos turnos (mañana y tarde)<br>
                - La elección del turno está sujeta al orden de mérito, fijándose un mínimo de 140 puntos para poder solicitarlo.<br>
                - Quienes ingresen y tengan hermanos/as cursando actualmente en el Colegio Nacional Monserrat pueden inscribirse en el mismo turno.<br>
                - No se realizan cambios de turnos de cursado.<br>
                - Cada aspirante puede visualizar de forma online el resultado de su examen; no se realiza publicación del orden de mérito.</font></p>
              <div class="error" style="margin-left: 2.5rem;" v-if="!item.hasStatementSelected">Campo requerido</div>
            </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTPFront, swal } from '../../share';
import { validationMixin } from 'vuelidate'
import { required,minLength,maxLength,requiredIf } from 'vuelidate/lib/validators'
import { dni } from '../../utils/validations'
import { mapGetters } from "vuex";

export default {
  props: ["clickedNext", "currentStep"],
  mixins: [validationMixin],
  data() {
    return {
      item: {
        minicourseSelected:'',
        latestGradeSelected:'',
        preferredShiftSelected:'',
        previousSchool: '',
        schoolTypeSelected:'',
        comment:'',
        hasSiblings:false,
        hasCourseSelected:false,
        hasStatementSelected:false,
        siblings:[],
        bros:[{
          name:'',
          lastName:'',
          documentNumber:'',
          division:''
          }
        ],
      },
      courses:[],
      latestGrades:null,
      preferredShifts: null,
      schoolTypes: null,
      activeShifts:[],
    };
  },
    validations: {
      item: {
        siblings:{
          required : requiredIf('tieneHermanos')
        },

        minicourseSelected:{
          required : requiredIf(function(){
            return (this.hasCourses.length>0 && this.item.hasCourseSelected)
          }),
        },
        latestGradeSelected:{
          required
        },
        preferredShiftSelected:{
          required
        },
        previousSchool:{
          required
        },
        schoolTypeSelected:{
          required
        },
        documentNumber:{
          dni,
          minLength : minLength(7),
          maxLength : maxLength(15)
        },
      }
  },
  computed:{
    ...mapGetters(["getAspirantData","getAspirantDataDocument","getLevel"]),
    hasCourses(){
      return this.courses = this.$route.params.call.courses;
    }
  },
  created() {
    this.courses = (this.$route.params.call.courses).slice(0,1);
    this.$emit("can-continue", { value: true });
    this.getLatestGrades();
    this.getPreferredShifts();
    this.getSchoolTypes();
    if (this.hasCourses.length>0) {
      this.getActiveShifts();
    }
  },
  watch: {
    $v: {
      handler: function (val) {
        if (!val.$invalid && !this.item.hasSiblings && this.item.hasStatementSelected) {
          // Formulario válido
          this.$store.commit('setStepThreeData', this.item)
          this.$emit("can-continue", { value: true });
        } else if(!val.$invalid && (this.item.hasSiblings && this.item.siblings.length>0) && this.item.hasStatementSelected){
          this.$store.commit('setStepThreeData', this.item)
          this.$emit("can-continue", { value: true });
        }
        else {
          this.$emit("can-continue", { value: false });
        }
      },
      deep: true,
    },

    clickedNext(val) {
      if (val === true) {
        this.$v.item.$touch();
      }
    },
    currentStep(){
      if(!this.$v.$invalid){
        this.$emit("can-continue", { value: true });
      }
    }
  },
  mounted() {
    if (!this.$v.$invalid) {
      this.$store.commit('setStepThreeData', this.item)
      this.$emit("can-continue", { value: true });
    } else {
      this.$emit("can-continue", { value: false });
    }
  },
  methods:{
    tieneCursos(){
      return this.courses.length>0
    },
    getMinicourses(){
      HTTPFront.get('/getMinicourses')
      .then(res => {
        this.miniCourses = res.data.rows;
      })
    },
    getLatestGrades(){
      HTTPFront.get('/getLatestGrades/'+this.getLevel)
      .then(res => {
        this.latestGrades = res.data.rows;
      })
    },
    getPreferredShifts(){
      HTTPFront.get('/getPreferredShifts/'+this.getLevel)
      .then(res => {
        this.preferredShifts = res.data.rows;
      })
    },
    getSchoolTypes(){
      HTTPFront.get('/getSchoolTypes/'+this.getLevel)
      .then(res => {
        this.schoolTypes = res.data.rows;
      })
    },
    getActiveShifts(){
      let params = {courseId: this.$route.params.call.courses[0].id, group: this.getLevel}
      HTTPFront.get('/getActiveShifts/' , {params})
      .then(res => {
        this.activeShifts = res.data;
      })
    },
    cleanSiblings(){
      this.item.siblings=[];
      if(!this.item.hasSiblings){
        this.item.siblings={}
        this.item.bros[0]={
          name:'',
          lastName:'',
          documentNumber:'',
          division:''
        }
      }
    },
    addSibling(bro){
      if(this.item.bros[0].name == '' || this.item.bros[0].lastName == '' || this.item.bros[0].documentNumber == '' || this.item.bros[0].division == ''){
        swal.fire({icon: 'warning', title: 'Faltan datos', text: 'Tiene que completar los datos del hermano', type: 'warning' });
      }else{
        this.item.siblings.push(bro)
        this.item.bros[0]={
          name:'',
          lastName:'',
          documentNumber:'',
          division:''
        }
      }
    },
    deleteSibling(index){
      this.item.siblings.splice(index,1);
    },
    tieneHermanos(){
      return this.item.hasSiblings
    },
    cleanCourses(){
      this.item.minicourseSelected = '';
    }

  }
};
</script>